import React from 'react';
import { HeadingText40 } from '@modernhealth/vital-components';

import { CircleRsvpQuestionFragment } from '../documents/topic.generated';
import { QuestionAnswer, QuestionAnswers } from '../types';
import Question from './RsvpQuestion';

interface QuestionsProps {
  questions: CircleRsvpQuestionFragment[];
  questionAnswers: QuestionAnswers;
  setQuestionAnswer: (answer: QuestionAnswer) => void;
  showErrors: boolean;
}

const Questions: React.FC<QuestionsProps> = ({
  questions,
  questionAnswers,
  setQuestionAnswer,
  showErrors,
}) => {
  return questions && questions.length ? (
    <div css={{ marginBottom: '32px' }}>
      <HeadingText40 css={{ marginBottom: '32px' }}>About this Session</HeadingText40>
      {questions.map(question => {
        if (!question) return null;
        const answerValue =
          question.__typename === 'CircleDropdownQuestionNode' ||
          question.__typename === 'CircleRadioGroupQuestionNode'
            ? questionAnswers[question.id]?.answerId
            : questionAnswers[question.id]?.answerText;

        return (
          <Question
            key={question.id}
            question={question}
            answer={answerValue ?? ''}
            setAnswer={setQuestionAnswer}
            showErrors={showErrors}
          />
        );
      })}
    </div>
  ) : null;
};

export default Questions;
